import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import PersonalizeEveryInteractionPng2x from './assets/PersonalizeEveryInteraction@2x.png'
import PersonalizeEveryInteractionWebp from './assets/PersonalizeEveryInteraction.webp'
import PersonalizeEveryInteractionWebp2x from './assets/PersonalizeEveryInteraction@2x.webp'

const PersonalizeEveryInteractionImage = () => {
  return (
    <Picture>
      <source
        type="image/webp"
        srcSet={`${PersonalizeEveryInteractionWebp}, ${PersonalizeEveryInteractionWebp2x} 2x`}
      />
      <Image
        src={PersonalizeEveryInteractionPng2x}
        alt="Illustration: Personalize every interaction"
        width="946"
        height="625"
        loading="lazy"
      />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default PersonalizeEveryInteractionImage
